/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReinsuredResponseDto } from './ReinsuredResponseDto';
import {
    ReinsuredResponseDtoFromJSON,
    ReinsuredResponseDtoFromJSONTyped,
    ReinsuredResponseDtoToJSON,
    ReinsuredResponseDtoToJSONTyped,
} from './ReinsuredResponseDto';
import type { BrokerResponseDto } from './BrokerResponseDto';
import {
    BrokerResponseDtoFromJSON,
    BrokerResponseDtoFromJSONTyped,
    BrokerResponseDtoToJSON,
    BrokerResponseDtoToJSONTyped,
} from './BrokerResponseDto';
import type { BinderResponseDto } from './BinderResponseDto';
import {
    BinderResponseDtoFromJSON,
    BinderResponseDtoFromJSONTyped,
    BinderResponseDtoToJSON,
    BinderResponseDtoToJSONTyped,
} from './BinderResponseDto';

/**
 * 
 * @export
 * @interface BindingDataContractResponseDto
 */
export interface BindingDataContractResponseDto {
    /**
     * 
     * @type {string}
     * @memberof BindingDataContractResponseDto
     */
    binderShareQuoted: string;
    /**
     * 
     * @type {number}
     * @memberof BindingDataContractResponseDto
     */
    layerNumber: number;
    /**
     * 
     * @type {string}
     * @memberof BindingDataContractResponseDto
     */
    limitType: BindingDataContractResponseDtoLimitTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BindingDataContractResponseDto
     */
    limit: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataContractResponseDto
     */
    excess?: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataContractResponseDto
     */
    premium: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataContractResponseDto
     */
    totalDeductions: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataContractResponseDto
     */
    layerId: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataContractResponseDto
     */
    contractId: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataContractResponseDto
     */
    binderId: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataContractResponseDto
     */
    brokerId: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataContractResponseDto
     */
    reinsuredId: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataContractResponseDto
     */
    contractStatus?: BindingDataContractResponseDtoContractStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BindingDataContractResponseDto
     */
    binderShareSigned?: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataContractResponseDto
     */
    shareOfLimitQuoted: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataContractResponseDto
     */
    shareOfPremiumQuoted: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataContractResponseDto
     */
    shareOfLimitSigned?: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataContractResponseDto
     */
    shareOfPremiumSigned?: string;
    /**
     * 
     * @type {BinderResponseDto}
     * @memberof BindingDataContractResponseDto
     */
    binder?: BinderResponseDto;
    /**
     * 
     * @type {ReinsuredResponseDto}
     * @memberof BindingDataContractResponseDto
     */
    reinsured?: ReinsuredResponseDto;
    /**
     * 
     * @type {BrokerResponseDto}
     * @memberof BindingDataContractResponseDto
     */
    broker?: BrokerResponseDto;
    /**
     * 
     * @type {boolean}
     * @memberof BindingDataContractResponseDto
     */
    isSlipUploaded: boolean;
}


/**
 * @export
 */
export const BindingDataContractResponseDtoLimitTypeEnum = {
    Primary: 'Primary',
    ExcessOfLoss: 'Excess of Loss',
    QuotaShare: 'Quota Share'
} as const;
export type BindingDataContractResponseDtoLimitTypeEnum = typeof BindingDataContractResponseDtoLimitTypeEnum[keyof typeof BindingDataContractResponseDtoLimitTypeEnum];

/**
 * @export
 */
export const BindingDataContractResponseDtoContractStatusEnum = {
    Bound: 'Bound',
    NotTakenUp: 'Not Taken Up',
    Cancelled: 'Cancelled',
    Quoted: 'Quoted',
    Pending: 'Pending'
} as const;
export type BindingDataContractResponseDtoContractStatusEnum = typeof BindingDataContractResponseDtoContractStatusEnum[keyof typeof BindingDataContractResponseDtoContractStatusEnum];


/**
 * Check if a given object implements the BindingDataContractResponseDto interface.
 */
export function instanceOfBindingDataContractResponseDto(value: object): value is BindingDataContractResponseDto {
    if (!('binderShareQuoted' in value) || value['binderShareQuoted'] === undefined) return false;
    if (!('layerNumber' in value) || value['layerNumber'] === undefined) return false;
    if (!('limitType' in value) || value['limitType'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('premium' in value) || value['premium'] === undefined) return false;
    if (!('totalDeductions' in value) || value['totalDeductions'] === undefined) return false;
    if (!('layerId' in value) || value['layerId'] === undefined) return false;
    if (!('contractId' in value) || value['contractId'] === undefined) return false;
    if (!('binderId' in value) || value['binderId'] === undefined) return false;
    if (!('brokerId' in value) || value['brokerId'] === undefined) return false;
    if (!('reinsuredId' in value) || value['reinsuredId'] === undefined) return false;
    if (!('shareOfLimitQuoted' in value) || value['shareOfLimitQuoted'] === undefined) return false;
    if (!('shareOfPremiumQuoted' in value) || value['shareOfPremiumQuoted'] === undefined) return false;
    if (!('isSlipUploaded' in value) || value['isSlipUploaded'] === undefined) return false;
    return true;
}

export function BindingDataContractResponseDtoFromJSON(json: any): BindingDataContractResponseDto {
    return BindingDataContractResponseDtoFromJSONTyped(json, false);
}

export function BindingDataContractResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BindingDataContractResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'binderShareQuoted': json['binderShareQuoted'],
        'layerNumber': json['layerNumber'],
        'limitType': json['limitType'],
        'limit': json['limit'],
        'excess': json['excess'] == null ? undefined : json['excess'],
        'premium': json['premium'],
        'totalDeductions': json['totalDeductions'],
        'layerId': json['layerId'],
        'contractId': json['contractId'],
        'binderId': json['binderId'],
        'brokerId': json['brokerId'],
        'reinsuredId': json['reinsuredId'],
        'contractStatus': json['contractStatus'] == null ? undefined : json['contractStatus'],
        'binderShareSigned': json['binderShareSigned'] == null ? undefined : json['binderShareSigned'],
        'shareOfLimitQuoted': json['shareOfLimitQuoted'],
        'shareOfPremiumQuoted': json['shareOfPremiumQuoted'],
        'shareOfLimitSigned': json['shareOfLimitSigned'] == null ? undefined : json['shareOfLimitSigned'],
        'shareOfPremiumSigned': json['shareOfPremiumSigned'] == null ? undefined : json['shareOfPremiumSigned'],
        'binder': json['binder'] == null ? undefined : BinderResponseDtoFromJSON(json['binder']),
        'reinsured': json['reinsured'] == null ? undefined : ReinsuredResponseDtoFromJSON(json['reinsured']),
        'broker': json['broker'] == null ? undefined : BrokerResponseDtoFromJSON(json['broker']),
        'isSlipUploaded': json['isSlipUploaded'],
    };
}

export function BindingDataContractResponseDtoToJSON(json: any): BindingDataContractResponseDto {
    return BindingDataContractResponseDtoToJSONTyped(json, false);
}

export function BindingDataContractResponseDtoToJSONTyped(value?: BindingDataContractResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'binderShareQuoted': value['binderShareQuoted'],
        'layerNumber': value['layerNumber'],
        'limitType': value['limitType'],
        'limit': value['limit'],
        'excess': value['excess'],
        'premium': value['premium'],
        'totalDeductions': value['totalDeductions'],
        'layerId': value['layerId'],
        'contractId': value['contractId'],
        'binderId': value['binderId'],
        'brokerId': value['brokerId'],
        'reinsuredId': value['reinsuredId'],
        'contractStatus': value['contractStatus'],
        'binderShareSigned': value['binderShareSigned'],
        'shareOfLimitQuoted': value['shareOfLimitQuoted'],
        'shareOfPremiumQuoted': value['shareOfPremiumQuoted'],
        'shareOfLimitSigned': value['shareOfLimitSigned'],
        'shareOfPremiumSigned': value['shareOfPremiumSigned'],
        'binder': BinderResponseDtoToJSON(value['binder']),
        'reinsured': ReinsuredResponseDtoToJSON(value['reinsured']),
        'broker': BrokerResponseDtoToJSON(value['broker']),
        'isSlipUploaded': value['isSlipUploaded'],
    };
}

